module.exports = __webpack_public_path__ + "static/media/tablets1.8ad0f4e0.png";